const utilityConfig = {
    utility: {
        filterLayout: 'UtilityFilterDefaultLayout',
        listLayout: 'UtilityListDefaultLayout',
        emptyLayout: 'UtilityEmptyDefalutLayout',
        paginationLayout: 'PaginationDefalutLayout',
        getFunc : 'getUtility',
        getUtilityCategory : 'getUtilityCategory',
        listApiParamSet : {
            ip:1,
            page:1,
            sp:10,
            uu: 1,
            u1: 1,
            uucnt:1,
        }
    },
    utilityAll: {
        filterLayout: 'UtilityFilterDefaultLayout',
        listLayout: 'UtilityListAllLayout',
        emptyLayout: 'UtilityEmptyDefalutLayout',
        paginationLayout: 'PaginationDefalutLayout',
        getFunc : 'getUtility',
        getUtilityCategory : 'getUtilityCategory',
        listApiParamSet : {
            ip:1,
            page:1,
            sp:10,
            uucnt:1,
        }
    },
    collectionUtility: {
        filterLayout: 'UtilityFilterDefaultLayout',
        listLayout: 'UtilityListDefaultLayout',
        emptyLayout: 'UtilityEmptyDefalutLayout',
        paginationLayout: 'PaginationDefalutLayout',
        getFunc : 'getUtility',
        getUtilityCategory : 'getUtilityCategory',
        listApiParamSet : {
            ip:1,
            page:1,
            sp:10,
            // uu:1,
            uucnt:1,
            uu_is_deal:[0,1]
        },
        keyName: 'c_idx'
    },
    itemUtility: {
        filterLayout: 'UtilityFilterDefaultLayout',
        listLayout: 'UtilityListDefaultLayout',
        emptyLayout: 'UtilityEmptyDefalutLayout',
        paginationLayout: 'PaginationDefalutLayout',
        getFunc : 'getUtility',
        getUtilityCategory : 'getUtilityCategory',
        listApiParamSet : {
            ip:1,
            page:1,
            sp:10,
            uu:1,
            uucnt:1,
            uu_is_deal: [0,1]
        },
        keyName: 'i_idx'
    },
    utilityDetail: {
        detailLayout: 'UtilityDetailDefaultLayout',
        getFunc: 'getUtility',
        detailApiParamSet: {
            uu: 1,
            ul: 1,
            uucnt:1,
        },
        keyName: 'uu_idx'
    },
    utilityPublish: {
        detailLayout: 'UtilityDetailPublishLayout',
        getFunc: 'getUtility',
        detailApiParamSet: {
            uucnt:1,
        },
        keyName: 'u_idx',
        deleteKeyName:'u_idx',
        deleteFunc: 'deleteUtility',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {
        },
        deleteErrorTypes: {},
    },
    utilityUse: {
        listLayout: 'UtilityListUseLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getUtility',
        listApiParamSet: {
            ip: 1,
            ul: 1,
        },
        keyName: 'uu_idx',
        pageRow: 10,
        paginationType: 'pagination',
    },
    utilityTransaction: {
        listLayout: 'UtilityListTransactionLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getUtilityTransaction',
        listApiParamSet: {
            ip: 1,
        },
        keyName: 'id',
        pageRow: 10,
        paginationType: 'pagination',
    },
    utilityPubCurrent: {
        filterLayout: 'UtilityFilterPubCurrentLayout',
        listLayout: 'UtilityListPubCurrentLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getUtility',
        listApiParamSet: {
            ip: 1,
            uu: 1,
            ul: 1,
        },
        keyName: 'u_idx',
        pageRow: 10,
        paginationType: 'pagination',
    },
    utilityManager: {
        filterLayout: 'UtilityFilterManagerLayout',
        listLayout: 'UtilityListManagerLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getUtilityManager',
        listApiParamSet: {
            ip: 1,
        },
        keyName: 'u_idx',
        pageRow: 10,
        paginationType: 'pagination',
    },
}

export default {
    methods : {
        returnUtilityConfig(type){
            return utilityConfig[type]
        }
    },
    filterConfig : {
        cr : { //발행일 / 매니저 매칭 날짜
            type : 'between',
            classname : 'filterDate'
        },
        sellst : {
            type : 'terms',
            classname : 'filterUtilitySalesStatus'
        },
        usest : {
            type : 'terms',
            classname : 'filterUtilityUseStatus'
        },
        // uu_is_deal : {
        //     type : 'terms',
        //     classname : 'filterUtilityUseStatus'
        // },
        uc_idx : {
            type : 'terms',
            classname : 'filterUtilityChildCategory'
        },
        u_name : {
            type : 'query',
            classname : 'searchInput'
        },
        dir_nick : {
            type : 'query',
            classname : 'searchInput'
        },
        owner_id : {
            type : 'query',
            classname : 'searchInput'
        },
        owner_nick : {
            type : 'query',
            classname : 'searchInput'
        },
        i_name : {
            type : 'query',
            classname : 'searchInput'
        },
        c_name : {
            type : 'query',
            classname : 'searchInput'
        },
        c_title : {
            type : 'query',
            classname : 'searchInput'
        },
        uc_parent_id : {
            type : 'terms',
            classname : 'filterUtilityParentCategory'
        },
        ni: { // 매니저 닉네임
            type: 'query',
            classname: 'searchInput',
        },
        na: { // 매니저 이름
            type: 'query',
            classname: 'searchInput',
        },
        mid: { // 매니저 아이디
            type: 'query',
            classname: 'searchInput',
        },
    }
}
